export default __webpack_public_path__ + "static/media/benefit_6.7829b757.png";